import { ILibraryGroup, ILibraryGroupWithPagination } from './libraryGroups.types'
import { HTTPResponse } from '@/services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '@/services/http'

const loadGroups = (): Promise<HTTPResponse<ILibraryGroupWithPagination>> => {
  return http.get(`/nsi/v1/library/groups?limit=${1000}`).then(handleHttpResponse).catch(handleHttpError)
}

const getGroup = (id: ILibraryGroup['id']): Promise<HTTPResponse<ILibraryGroup>> => {
  return http.get(`/nsi/v1/library/groups/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const createGroup = (dto: Omit<ILibraryGroup, 'id'>): Promise<HTTPResponse<ILibraryGroup>> => {
  return http.post(`/nsi/v1/library/groups`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateGroup = (dto: ILibraryGroup): Promise<HTTPResponse<ILibraryGroup>> => {
  return http.patch(`/nsi/v1/library/groups/${dto.id}`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const deleteGroup = (id: ILibraryGroup['id']): Promise<HTTPResponse<ILibraryGroup>> => {
  return http.delete(`/nsi/v1/library/groups/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const libraryGroupsApi = { loadGroups, getGroup, createGroup, updateGroup, deleteGroup }

export default libraryGroupsApi
